export default __webpack_public_path__ + "static/media/milk1.95b4d015.png";